import { Base64 } from "@/app/base64";

function base64ToUint8Array(base64: string): Uint8Array;
function base64ToUint8Array(
  base64: string | null | undefined
): Uint8Array | null {
  if (base64 === null || base64 === undefined) {
    return null;
  }
  return Base64.toUint8Array(base64);
}

export default {
  base64ToUint8Array,
  uint8ArrayToBase64(
    arrayBuffer: Uint8Array | undefined | null
  ): string | undefined {
    return arrayBuffer ? Base64.fromUint8Array(arrayBuffer) : undefined;
  },
};
